import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useCurrency } from 'hooks/useCurrency';
import { getIsLoggedIn } from 'store/selectors/user-data';

type TFormatAmount = (
  amount: Parameters<ReturnType<typeof useCurrency>['formatAmount']>[0]
) => ReturnType<ReturnType<typeof useCurrency>['formatAmount']>;

type TUseFormatAmount = () => TFormatAmount;

export const useFormatAmount: TUseFormatAmount = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const { formatAmount: _formatAmount } = useCurrency();

  return useCallback<TFormatAmount>(
    amount => _formatAmount(amount, isLoggedIn),
    [isLoggedIn, _formatAmount]
  );
};
